import React, { FunctionComponent } from 'react';
import styles from './ImageButtons.scss';
import Button from '../../Button/Button';
import clientConfig from '../../../client/config';
import Svg from '@justgiving/svg';
import { galleryIcon } from '@justgiving/icons';
import { usePageOwner } from '../../../hooks/usePageOwner';
import { useNotNullableContext } from '../../../hooks/useNotNullableContext';
import { PageMetaContext } from '../../../context/PageMetaContext';
import { useTranslation } from 'react-i18next';

interface ImageButtonsProps {
  onViewGallery: () => void;
}

const ImageButtons: FunctionComponent<ImageButtonsProps> = ({
  onViewGallery,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isPageOwner } = usePageOwner();
  const { pageShortName } = useNotNullableContext(PageMetaContext);

  return (
    <div className={styles.wrapper} data-qa="image-buttons">
      {isPageOwner ? (
        <>
          <Button
            className={styles.button}
            onClick={onViewGallery}
            aria-label={t('common.openGallery', 'Open the Image Gallery')}
          >
            {t('common.viewGallery', 'View gallery')}
          </Button>
          <a href={`${clientConfig.baseUri}/fundraising-edit/${pageShortName}`}>
            <Button className={styles.button}>
              {t('common.changeCover', 'Change cover')}
            </Button>
          </a>
        </>
      ) : (
        <Button
          className={styles.button}
          onClick={onViewGallery}
          aria-label={t('common.openGallery', 'Open the Image Gallery')}
        >
          <Svg markup={galleryIcon} className={styles.icon} />
        </Button>
      )}
    </div>
  );
};

export default ImageButtons;
